import { Helmet } from 'react-helmet-async';
import { Navigate, useParams } from 'react-router';

import { hasPermission } from 'src/utils/has-permissions';

import { useAuthContext } from 'src/auth/hooks';
import { AuthPermissions } from 'src/auth/permissions';

import PackagingStockCountDetailView from 'src/sections/packaging-stock-count/view/packaging-stock-count-detail-view';

export default function PackagingStockCountDetailPage() {
  const { user: authUser } = useAuthContext();

  const params = useParams();

  const { id } = params;

  return (
    <>
      <Helmet>
        <title> Packaging stock count details</title>
      </Helmet>

      {hasPermission(
        authUser,
        'any',
        AuthPermissions.ADMIN_PERMISSION,
        AuthPermissions.SUPER_ADMIN_PERMISSION
      ) ? (
        <PackagingStockCountDetailView id={`${id}`} />
      ) : (
        <Navigate to="/403" />
      )}
    </>
  );
}
